import { useGsap } from '~/lib/gsap'
import { useSplide } from '~/lib/splide'


document.addEventListener('DOMContentLoaded', () => {

  useSplide('.banner__home', {
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    arrows: false,
    type: 'loop',
  })
    ?.then((splide) => {
      splide?.mount()
    })

  useGsap()
    ?.then(gsap => {
      const counters = document.querySelectorAll('.counter')
      const duration = 3 // Duración en segundos (GSAP trabaja en segundos)

      counters.forEach(el => {
        const number = el.getAttribute('data-counter')
        if (!number) return

        const counterNumber = el.querySelector('.number')
        if (!counterNumber) return

        const finalNumber = parseInt(number) || 0
        const increment = finalNumber > 50 ? Math.floor(finalNumber * 0.033) : 1
        const totalSteps = Math.floor(finalNumber / increment)

        gsap.fromTo(counterNumber,
          { innerText: 0 },
          {
            innerText: finalNumber,
            duration,
            ease: 'sine.out',
            roundProps: 'innerText',
            snap: { innerText: 1 },
            onUpdate: () => {
              const progress = Number(gsap.getProperty(counterNumber, 'innerText')) / finalNumber
              let currentStepValue = Math.floor(progress * totalSteps) * increment
              counterNumber.textContent = Math.min(currentStepValue, finalNumber).toFixed(0)
            },
            onComplete: () => {
              counterNumber.textContent = finalNumber.toString()
            },
            scrollTrigger: {
              trigger: el,
              start: 'top 90%',
              end: 'bottom 30%',
              toggleActions: 'play none none reverse',
            }
          }
        )
      })

    }) 
})